"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dashboard = exports.UppyUploader = void 0;
const tslib_1 = require("tslib");
const aws_s3_1 = tslib_1.__importDefault(require("@uppy/aws-s3"));
const box_1 = tslib_1.__importDefault(require("@uppy/box"));
const core_1 = tslib_1.__importDefault(require("@uppy/core"));
require("@uppy/core/dist/style.min.css");
const dashboard_1 = tslib_1.__importDefault(require("@uppy/dashboard"));
exports.Dashboard = dashboard_1.default;
require("@uppy/dashboard/dist/style.min.css");
const dropbox_1 = tslib_1.__importDefault(require("@uppy/dropbox"));
const facebook_1 = tslib_1.__importDefault(require("@uppy/facebook"));
const image_editor_1 = tslib_1.__importDefault(require("@uppy/image-editor"));
require("@uppy/image-editor/dist/style.min.css");
const onedrive_1 = tslib_1.__importDefault(require("@uppy/onedrive"));
const url_1 = tslib_1.__importDefault(require("@uppy/url"));
const webcam_1 = tslib_1.__importDefault(require("@uppy/webcam"));
require("@uppy/webcam/dist/style.min.css");
const uploader_types_1 = require("./uploader.types");
const uploader_utils_1 = require("./uploader.utils");
class UppyUploader {
    constructor(type, options) {
        const restrictions = this.getRestrictions(options.restrictions, type);
        const providerConfig = {
            target: dashboard_1.default,
            companionUrl: options.companionUrl,
        };
        const webcamConfig = this.getWebcamConfig(restrictions);
        const awsS3Config = {
            limit: 5,
            companionUrl: options.companionUrl,
        };
        this.uppy = new core_1.default();
        this.uppy.setOptions({
            restrictions,
            onBeforeUpload: (files) => this.onBeforeUpload(files, options.bucket, options.objectKey),
        });
        this.uppy
            .use(dashboard_1.default, {
            target: 'body',
            inline: false,
            showProgressDetails: true,
            proudlyDisplayPoweredByUppy: false,
            thumbnailWidth: 280,
            showLinkToFileUploadResult: false,
            closeModalOnClickOutside: true,
            disableThumbnailGenerator: false,
            showSelectedFiles: true,
            showRemoveButtonAfterComplete: false,
            browserBackButtonClose: false,
            theme: 'light',
        })
            // .use(GoogleDrive, providerConfig)
            .use(dropbox_1.default, providerConfig)
            .use(box_1.default, providerConfig)
            .use(onedrive_1.default, providerConfig)
            .use(facebook_1.default, providerConfig)
            .use(url_1.default, providerConfig)
            .use(image_editor_1.default)
            .use(aws_s3_1.default, awsS3Config)
            .use(webcam_1.default, webcamConfig);
    }
    onBeforeUpload(files, bucket, objectKey) {
        return (0, uploader_utils_1.createObjectKey)(files, bucket, objectKey);
    }
    getRestrictions(restrictions, type) {
        if (restrictions)
            return Object.assign(Object.assign({}, restrictions), { allowedFileTypes: restrictions.allowedFileTypes ||
                    uploader_types_1.ASSET_MIME_TYPES[type || 'image'] ||
                    [] });
        const defaultRestrictions = {
            maxFileSize: 0,
            maxNumberOfFiles: 0,
            minNumberOfFiles: 0,
            allowedFileTypes: uploader_types_1.ASSET_MIME_TYPES[type || 'image'] || [],
            requiredMetaFields: [],
        };
        return defaultRestrictions;
    }
    getWebcamConfig(restrictions) {
        const allowedTypes = restrictions.allowedFileTypes;
        const modes = [];
        if (allowedTypes === null || allowedTypes === void 0 ? void 0 : allowedTypes.some((type) => type.includes('video'))) {
            modes.push('video-audio');
        }
        if (allowedTypes === null || allowedTypes === void 0 ? void 0 : allowedTypes.some((type) => type.includes('audio'))) {
            modes.push('audio-only');
        }
        if (allowedTypes === null || allowedTypes === void 0 ? void 0 : allowedTypes.some((type) => type.includes('image'))) {
            modes.push('picture');
        }
        return {
            modes,
            mirror: false,
            showRecordingLength: !modes.includes('picture'),
            preferredVideoMimeType: 'video/webm',
        };
    }
    getUppy() {
        return this.uppy;
    }
    off(eventName, callback) {
        /**
         * Uppy off method has type issues
         */
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.uppy.off(eventName, callback !== null && callback !== void 0 ? callback : null);
    }
}
exports.UppyUploader = UppyUploader;
//# sourceMappingURL=uploader.uppy.js.map